import { Tag } from 'antd';

export const InternalTag = ({ isInternal }: { isInternal?: boolean | null }) =>
	isInternal ? <Tag color="purple">Internal</Tag> : null;
